module.exports = __webpack_public_path__ + "b078d3230370247e0bc4bb764f9c6a18.MP3";